"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetBikeRentalStation = createGetBikeRentalStation;
exports.createGetBikeRentalStations = createGetBikeRentalStations;
exports.createGetBikeRentalStationsByPosition = createGetBikeRentalStationsByPosition;

var _api = require("../api");

var _query = require("./query");

var _utils = require("../utils");

var _config = require("../config");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function createGetBikeRentalStation(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getBikeRentalStation(stationId) {
    var variables = {
      id: stationId
    };
    return (0, _api.journeyPlannerQuery)(_query.getBikeRentalStationQuery, variables, config).then(function (data) {
      return data === null || data === void 0 ? void 0 : data.bikeRentalStation;
    });
  };
}

function createGetBikeRentalStations(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getBikeRentalStations(stationIds) {
    if (!stationIds || !Array.isArray(stationIds)) {
      throw new Error("getBikeRentalStations takes an array of strings, but got ".concat(_typeof(stationIds)));
    }

    if (stationIds.length === 0) {
      return Promise.resolve([]);
    }

    var variables = {
      ids: stationIds
    };
    return (0, _api.journeyPlannerQuery)(_query.getBikeRentalStationsQuery, variables, config).then(function (data) {
      return (data === null || data === void 0 ? void 0 : data.bikeRentalStations) || [];
    }).then(function (stations) {
      return (0, _utils.forceOrder)(stations, stationIds, function (_ref) {
        var id = _ref.id;
        return id;
      });
    });
  };
}

function createGetBikeRentalStationsByPosition(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getBikeRentalStationsByPosition(coordinates) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var variables = (0, _utils.convertPositionToBbox)(coordinates, distance);
    return (0, _api.journeyPlannerQuery)(_query.getBikeRentalStationsByPositionQuery, variables, config).then(function (data) {
      return (data === null || data === void 0 ? void 0 : data.bikeRentalStationsByBbox) || [];
    });
  };
}